import { render, staticRenderFns } from "./EditBancarizador.vue?vue&type=template&id=ffd1240a&"
import script from "./EditBancarizador.vue?vue&type=script&lang=js&"
export * from "./EditBancarizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports